import React from 'react'
import AddIcon from '../../assets/icons/AddIcon'
import ViewStaffIcon from '../../assets/icons/ViewStaff'
import PageWrapper from '../../components/PageWrapper'
import Tab from '../../components/Tab/Tab'
import ViewStaffs from './ViewStaffs'
import AddStaffs from './AddStaff'
import EditStaffs from './EditStaff'
import Metadata from '../../components/Metadata'

  const staffsMetadata = {
    title: 'Staffs - Safelto',
    description: 'Manage staff members, view staff information, and handle staff management. Complete staff management solution.',
    keywords: ['staffs', 'staff management', 'staff information', 'property management', 'estate management'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/staffs',
    type: 'website' as 'website'
  }

  const Staffs = () => {
    const [numOfStaffs, setNumOfStaffs] = React.useState(0)
    const [currentView, setCurrentView] = React.useState('')
    const [loading, setLoading] = React.useState(true)
    const [staffMemberId, setStaffMemberId] = React.useState('')
    const isActiveView = (view: string) => {
      return view === currentView
    }

    const handleStaffCount = (num: number) => {
      setNumOfStaffs(num)
    }

    const handleViewSelect = (view: string, queries?: Record<string, string>) => {
      if (isActiveView(view)) {
        return
      }
      let queryArr = [`active=${view}`]
      for (let key in queries) {
        queryArr.push(`${key}=${queries[key]}`)
      }
      window.history.replaceState({...queries}, '', `?${queryArr.join('&')}`)
      setCurrentView(view)
    }

    React.useEffect(() => {
      const search = window.location.search.substring(1)
      const searchObj = search
        ? JSON.parse(
            `{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
            function (key, value) {
              return key === '' ? value : decodeURIComponent(value)
            }
          )
        : { active: 'view' }
      setLoading(false)

      setCurrentView(searchObj.active)
    }, [])

    React.useEffect(() => {}, [currentView])

    const renderViewModule = (isSpinning: boolean) => {
      switch (currentView) {
        case 'view':
          return (
            <ViewStaffs
              setNumOfStaffs={handleStaffCount}
              handleViewSelect={handleViewSelect}
              setStaffMemberId={setStaffMemberId}
              isSpinning={isSpinning}
            />
          )
        case 'add':
          return <AddStaffs handleViewSelect={handleViewSelect} />

        case 'edit':
          return <EditStaffs staffMemberId={staffMemberId} />
        default:
          return <p>Loading...</p>
      }
    }

    return (
      <PageWrapper title="Staffs" description="Add and view staffs here">
        <Metadata {...staffsMetadata} />
      <div className="justify-between flex flex-wrap">
        <div className="flex gap-10">
          <Tab
            text={'View staffs'}
            Icon={ViewStaffIcon}
            active={isActiveView('view')}
            onClick={() => handleViewSelect('view')}
          />
          <Tab
            text={'Add staff'}
            Icon={AddIcon}
            active={isActiveView('add')}
            onClick={() => handleViewSelect('add')}
          />
        </div>

        {isActiveView('view') ? (
          <div className="flex gap-5 items-center p-2.5 whitespace-nowrap h-fit bg-gray-100 rounded">
            <div className="flex bg-gray-900 w-9 h-9 rounded items-center justify-center">
              <ViewStaffIcon active={true} />
            </div>
            <p className="">Total number of staffs: {numOfStaffs}</p>
          </div>
        ) : null}
      </div>
      <div>{renderViewModule(loading)}</div>
    </PageWrapper>
  )
}

export default Staffs
